import { Component, OnInit} from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'ct-progress-bar',
  templateUrl: './ct-progress-bar.component.html',
  styleUrls: ['./ct-progress-bar.component.css']
})

export class CtProgressBarComponent extends CtrlBaseComponent implements OnInit {

  private progressPercentage: number = 1;
  private porcentageLimit: number = 100;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  public progressing() {
    if (this.getProgressPercentage() > this.getPorcentageLimit()) {
      this.progressPercentage = this.getPorcentageLimit();
    }
    if (this.getProgressPercentage() < 1) {
      this.progressPercentage = 1;
    }
  }

  getProgressPercentage(): number { return this.progressPercentage; }
  getPorcentageLimit(): number { return this.porcentageLimit; }
  setProgressPercentage(progressPercentage: number) { 
    this.progressPercentage = progressPercentage; 
    this.progressing();
  }
  setPorcentageLimit(porcentageLimit: number) { this.porcentageLimit = porcentageLimit; }
}